/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_Row_2Inputs */

const en_services_svc_full_art_row_2 = /** @type {(inputs: Services_Svc_Full_Art_Row_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spend over the daily budget`)
};

const lv_services_svc_full_art_row_2 = /** @type {(inputs: Services_Svc_Full_Art_Row_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tēriņi pārsniedz dienas budžetu`)
};

/**
* | output |
* | --- |
* | "Spend over the daily budget" |
*
* @param {Services_Svc_Full_Art_Row_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_row_2 = /** @type {((inputs?: Services_Svc_Full_Art_Row_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_Row_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_row_2(inputs)
	return en_services_svc_full_art_row_2(inputs)
});